import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface QuarterYearPickerProps {
  value: Date | null;
  onChange: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
  disabled?: boolean;
  placeholderText?: string;
  wrapperClassName?: string;
}

const QuarterYearPicker = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabled = false,
  placeholderText = "Select quarter",
  wrapperClassName,
}: QuarterYearPickerProps) => {
  return (
    <DatePicker
      selected={value}
      onChange={onChange}
      dateFormat="yyyy-QQQ"
      showQuarterYearPicker
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      placeholderText={placeholderText}
      className="form-control"
      wrapperClassName={wrapperClassName}
    />
  );
};

export default QuarterYearPicker;
